export class FilterQueryFilters {
  // Date filter
  date_from?: string[] = null;
  date_to?: string[] = null;

  [query_param: string]: string[];
}
